import { useMsal } from "@azure/msal-react";

interface UserProfile {
  name?: string;
  email?: string;
  username?: string;
  homeAccountId?: string;
}

/**
 * Hook to get current user profile information
 * Simplifies access to user data from MSAL accounts
 */
export const useUserProfile = (): UserProfile | null => {
  const { accounts } = useMsal();

  if (accounts.length === 0) {
    return null;
  }

  const account = accounts[0];

  return {
    name: account.name,
    email: account.username, // In MSAL, username often contains the email
    username: account.username,
    homeAccountId: account.homeAccountId,
  };
};
